export default ({ store }) => {
  if (!store.getters['admins/onboardersLoaded']) {
    return store.dispatch('admins/loadOnboarders')
  }
}
